import { invoices } from '@markku/db'
import { createInsertSchema, createSelectSchema } from 'drizzle-zod'
import { z } from 'zod'
import { withAttachments } from './attachment'

export const selectInvoiceSchema = createSelectSchema(invoices)
export const selectInvoiceWithAttachmentsSchema =
  withAttachments(selectInvoiceSchema)

export const insertInvoiceSchema = createInsertSchema(invoices).omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  deletedAt: true,
})

export type Invoice = z.infer<typeof selectInvoiceSchema>
export type InvoiceWithAttachments = z.infer<
  typeof selectInvoiceWithAttachmentsSchema
>
export type CreateInvoice = z.infer<typeof insertInvoiceSchema>
